import { render, staticRenderFns } from "./ListagemMemberkit.vue?vue&type=template&id=315cda75&scoped=true&"
import script from "./ListagemMemberkit.vue?vue&type=script&lang=js&"
export * from "./ListagemMemberkit.vue?vue&type=script&lang=js&"
import style0 from "./ListagemMemberkit.vue?vue&type=style&index=0&id=315cda75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315cda75",
  null
  
)

export default component.exports